import { render, staticRenderFns } from "./BatteryMessagesTab.vue?vue&type=template&id=695ecfd8"
import script from "./BatteryMessagesTab.vue?vue&type=script&lang=js"
export * from "./BatteryMessagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports